function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { useTheme } from "@material-ui/core";
import ParcelLogo from "../ParcelLogo";
import { useDeferredValue, useMapSize } from "../../hooks";
import { HEADER_HEIGHT } from "../../constants/values";
import FallBackImage from "../FallBackImage";
import TimeProgress from "./TimeProgress";
import { getMapImage } from "../../utils/images";
import { Identity } from "../Icons";
import { ID_MESSAGE } from "./constants";
import plug from "../../images/Electric/PlugMobile.png";
import TitleWithNumber from "../TitleWithNumber";
import { useEnvContext } from "../../env";
import defaultMap from "../../images/tracking.jpg";
const useStyles = makeStyles(({
  zIndex,
  palette,
  typography
}) => ({
  wrapper: ({
    mapHeight
  }) => ({
    position: "absolute",
    zIndex: 1,
    bottom: 0,
    background: palette.background.dialog,
    width: "100%",
    minHeight: typography.pxToRem(575),
    top: mapHeight + HEADER_HEIGHT,
    borderRadius: typography.pxToRem(3)
  }),
  container: {
    position: "relative",
    padding: `${typography.pxToRem(45)} ${typography.pxToRem(20)} ${typography.pxToRem(230)}`
  },
  parcelStatus: {
    letterSpacing: 0.44,
    color: palette.text.primary,
    fontSize: typography.pxToRem(12),
    lineHeight: typography.pxToRem(15),
    textAlign: "center",
    marginBottom: typography.pxToRem(30)
  },
  parcelStatusElectric: {
    marginBottom: typography.pxToRem(8)
  },
  logo: {
    position: "absolute",
    top: typography.pxToRem(-25),
    padding: `${typography.pxToRem(6)} ${typography.pxToRem(12)}`,
    height: typography.pxToRem(57),
    borderWidth: 1.8,
    borderColor: palette.border.mobileLogoOFD
  },
  currentStatus: {
    color: palette.text.secondary,
    fontWeight: 300,
    letterSpacing: 0.44,
    fontSize: typography.pxToRem(12),
    marginTop: typography.pxToRem(15),
    textAlign: "center"
  },
  bottomLine: {
    paddingBottom: typography.pxToRem(15),
    borderBottom: `1px solid #808285`
  },
  imgContainer: {
    display: "flex"
  },
  img: {
    position: "fixed",
    top: HEADER_HEIGHT,
    left: 0,
    width: "100%"
  },
  electricStatus: {
    fontSize: typography.pxToRem(11.5),
    fontFamily: '"PlutoSansRegular", sans-serif',
    color: palette.text.highlightSuccess,
    marginTop: typography.pxToRem(23),
    textAlign: "center"
  },
  idStatus: {
    fontSize: typography.pxToRem(11.5),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: typography.pxToRem(19)
  },
  idMessage: {
    marginLeft: typography.pxToRem(10)
  },
  plugImg: {
    width: `calc(100% + ${typography.pxToRem(24)})`,
    marginBottom: typography.pxToRem(30),
    marginRight: typography.pxToRem(-56),
    marginLeft: typography.pxToRem(-40)
  },
  fallbackImage: ({
    mapHeight
  }) => ({
    height: mapHeight,
    objectFit: "cover"
  })
}));

const OutForDeliveryMobileView = ({
  code,
  customerImageLogo,
  deliveryNumber,
  statusHtml,
  query,
  electricMessage,
  isVehicleElectric,
  showIdMessage,
  progressData,
  additionalInfo
}) => {
  const [mapWidth, mapHeight] = useMapSize();
  const {
    API_HOST
  } = useEnvContext();
  const {
    eventName
  } = useTheme();
  const mapSrc = getMapImage({
    apiHost: API_HOST,
    query,
    code,
    width: mapWidth,
    height: mapHeight,
    themeEvent: eventName
  });
  const styles = useStyles({
    mapHeight
  });
  const deferredMapSrc = useDeferredValue(mapSrc, 200);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.imgContainer
  }, /*#__PURE__*/React.createElement(FallBackImage, {
    src: deferredMapSrc,
    className: styles.img,
    fallBackSrc: defaultMap,
    fallBackStyles: styles.fallbackImage,
    alt: "map"
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.wrapper
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "column",
    justify: "center",
    alignItems: "center",
    className: styles.container
  }, /*#__PURE__*/React.createElement(ParcelLogo, {
    className: styles.logo,
    image: customerImageLogo
  }), /*#__PURE__*/React.createElement(TitleWithNumber, {
    title: deliveryNumber
  }), /*#__PURE__*/React.createElement(Typography, {
    className: clsx(styles.parcelStatus, {
      [styles.parcelStatusElectric]: isVehicleElectric
    }),
    dangerouslySetInnerHTML: {
      __html: statusHtml
    }
  }), isVehicleElectric && /*#__PURE__*/React.createElement("img", {
    src: plug,
    alt: "plug",
    className: styles.plugImg
  }), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "row"
  }, progressData.showProgressBar && /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "column",
    justify: "space-between",
    className: styles.progressContainer
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(TimeProgress, _extends({
    isVehicleElectric: isVehicleElectric
  }, progressData))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    className: styles.bottomLine
  }, /*#__PURE__*/React.createElement(Typography, {
    className: styles.currentStatus
  }, progressData.progressStatus), additionalInfo && /*#__PURE__*/React.createElement(Typography, {
    className: styles.currentStatus
  }, additionalInfo), isVehicleElectric && /*#__PURE__*/React.createElement(Typography, {
    className: styles.electricStatus
  }, electricMessage)), showIdMessage && /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Typography, {
    className: styles.idStatus
  }, /*#__PURE__*/React.createElement(Identity, null), /*#__PURE__*/React.createElement("span", {
    className: styles.idMessage
  }, ID_MESSAGE))))))));
};

export default OutForDeliveryMobileView;